module.exports = __webpack_public_path__ + "static/media/06-drag.d814afc8.png";